export const CHILDREN_PRIVACY = {
    title: '儿童隐私保护声明',
    date: '2024年5月25日',
    abstraction: {context: '上海屋聚公共租赁住房运营有限公司（以下简称“本公司”或“我们”）深知儿童隐私保护的重要性，并承诺将采取一切必要措施，确保儿童的个人信息安全和隐私权益得到充分保障。以下是我们针对儿童隐私保护的具体声明：'},
    protocols: [
        {
            name: '儿童信息收集与使用的原则',
            details: [
                { context: '我们仅在法律允许、父母或法定监护人明确同意，且符合儿童最大利益的前提下，收集、使用、存储和传输儿童的个人信息。' },
                { context: '我们将严格遵守相关法律法规，确保儿童信息的合法、正当、必要原则，不收集与业务无关的儿童信息。' },
                { context: '我们将采取加密、脱敏等技术手段，确保儿童信息在收集、存储、使用、传输过程中的安全性。' }
            ]
        },
        {
            name: '儿童信息的使用范围',
            details: [
                { context: '我们将儿童信息用于提供租赁住房服务、优化服务体验、保障儿童安全等目的。' },
                { context: '未经父母或法定监护人明确同意，我们不会将儿童信息用于其他任何与上述目的无关的活动。' }
            ]
        },
        {
            name: '儿童信息的共享与披露',
            details: [
                { context: '我们不会向任何第三方共享或披露儿童信息，除非法律允许或父母或法定监护人明确同意。' },
                { context: '在与第三方合作过程中，我们将与第三方签订严格的保密协议，确保儿童信息的安全性和隐私性。' }
            ]
        },
        {
            name: '父母或法定监护人的权利',
            details: [
                { context: '父母或法定监护人有权随时查阅、更正、删除儿童在本公司收集的信息。' },
                { context: '父母或法定监护人有权拒绝我们收集、使用、存储、传输儿童信息的请求。' },
                { context: '父母或法定监护人可通过我们提供的联系方式（如客服热线、官方邮箱等），与我们取得联系，行使上述权利。' }
            ]
        },
        {
            name: '安全教育与宣传',
            details: [
                { context: '我们将加强员工的安全意识培训，确保员工充分了解并遵守儿童隐私保护的相关法律法规和公司政策。' },
                { context: '我们将通过官方网站、社交媒体等渠道，向公众宣传儿童隐私保护的重要性，提高公众对儿童隐私保护的认识和重视程度。' }
            ]
        },
        {
            name: '违规处理与投诉渠道',
            details: [
                { context: '如发现我们违反本声明或相关法律法规，侵犯儿童隐私权益的行为，我们将依法承担相应的法律责任。' },
                { context: '如有任何关于儿童隐私保护的疑问、建议或投诉，请通过我们提供的联系方式与我们取得联系，我们将尽快处理并回复。' }
            ]
        }
    ],

}